import Tag from './index.vue'

Tag.install = (Vue) => {
  Vue.component(Tag.name, Tag)
}

// 导出组件
export default Tag
